import cn from 'classnames'

import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'

export function Box({ children, className }: FunctionComponentType) {
  return (
    <section
      className={cn(
        'border border-gray-4 dark:border-purple rounded-[8px] desktop-tablet:p-[30px] desktop-tablet:shadow-card tablet:pl-[30px] tablet:py-[30px] mobile:px-[21px] mobile:pt-[10px] mobile:border-0 ',
        className
      )}
    >
      {children}
    </section>
  )
}

Box.Title = function BoxTitle({ children }: FunctionComponentType) {
  return (
    <div className='font-mitr font-medium text-[24px] text-secondary dark:text-dark-10 mb-[20px] mobile:mb-[10px]'>
      {children}
    </div>
  )
}
